<template>
  <v-dialog
    v-model="display"
    max-width="700px"
  >
    <v-card>
      <v-card-title>
        <h4>{{ recordsTitle }}</h4>
      </v-card-title>
      <v-card-text>
        <v-data-table
          id="records-table"
          :headers="recordsHeaders"
          :items="records"
          class="elevation-1 rounded"
          hide-default-footer
          disable-pagination
        >
          <template #[`item.id`]="{ item }">
            <a
              href="#"
              @click.prevent="() => goToRecord(item)"
            >{{ item.id }}</a>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn
          text
          @click="$emit('close-dialog')"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'RecordsDialog',

  props: {
    displayDialog: {
      type: Boolean,
      required: true,
    },

    partyName: {
      type: String,
      default: '',
    },

    records: {
      type: Array,
      default: _ => ([]),
    },
  },

  data () {
    return {
      recordsHeaders: [
        { text: 'ID', value: 'id' },
        { text: 'Record Holder', value: 'record_holder' },
      ],
    }
  },

  computed: {
    display: {
      get () {
        return this.displayDialog
      },

      set (newValue) {
        if (!newValue) this.$emit('close-dialog')
      },
    },

    recordsTitle () {
      return this.partyName ? 'Records associated with ' + this.partyName : 'Records'
    },
  },

  methods: {
    goToRecord (record) {
      if (!record) return

      this.$router.push(`/record/${record.id}`)
    },
  },
}
</script>
